/* unplugin-vue-components disabled */import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useThemeStore } from '@/stores/theme';
export default {
  __name: 'PrintSideLabel',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const themeStore = useThemeStore();
    const {
      theme
    } = storeToRefs(themeStore);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["inline-block relative side-label--text uppercase tracking-widest text-[14px]", {
          'opacity-70': !__props.isActive,
          'text-slate-500': _unref(theme) === 'light',
          'text-slate-300': _unref(theme) === 'dark'
        }])
      }, [_renderSlot(_ctx.$slots, "default"), _createElementVNode("span", {
        class: _normalizeClass(["absolute top-1/2 -translate-y-1/2 -right-5 w-2 h-2 rounded-[50%]", {
          'bg-lime-500': __props.isActive && _unref(theme) === 'light',
          'bg-lime-400': __props.isActive && _unref(theme) === 'dark',
          'bg-slate-300': _unref(theme) === 'dark' && !__props.isActive,
          'bg-slate-500': _unref(theme) === 'light' && !__props.isActive
        }])
      }, null, 2)], 2);
    };
  }
};